export const profits = {
  'backoffice.profits.accountsSummary.title': 'Riepilogo Profitti dei Conti',
  'backoffice.profits.accountsSummary.subtitle': 'Panoramica delle performance di profitto di tutti i tuoi conti di investimento',
  'backoffice.profits.accountsHistory.title': 'Cronologia Profitti dei Conti',
  'backoffice.profits.accountsHistory.subtitle': 'Dati storici dettagliati dei profitti dei tuoi conti di investimento',
  'backoffice.profits.commissionsSummary.title': 'Riepilogo Commissioni',
  'backoffice.profits.commissionsSummary.subtitle': 'Panoramica delle tue commissioni di referral e guadagni',
  'backoffice.profits.commissionsHistory.title': 'Cronologia Commissioni',
  'backoffice.profits.commissionsHistory.subtitle': 'Cronologia dettagliata dei guadagni da commissioni e transazioni',
  'backoffice.profits.commissionsPaymentHistory.title': 'Cronologia Pagamenti Commissioni',
  'backoffice.profits.commissionsPaymentHistory.subtitle': 'Traccia tutti i pagamenti delle commissioni e la cronologia dei prelievi',
  'backoffice.profits.common.loading': 'Caricamento dati profitti...',
  'backoffice.profits.common.error': 'Errore nel caricamento delle informazioni sui profitti',
  'backoffice.profits.common.noData': 'Nessun dato sui profitti disponibile',
  'backoffice.profits.common.comingSoon': 'Questa funzionalità sarà presto disponibile',
  'backoffice.profits.common.placeholder': 'I dettagli dei profitti saranno visualizzati qui una volta implementati',
  'backoffice.profits.lifetime.title': 'Profitti dei Conti a Vita',
  'backoffice.profits.lifetime.totalProfit': 'Profitto Totale a Vita',
  'backoffice.profits.lifetime.accountProfit': 'Profitto del Conto',
  'backoffice.profits.lifetime.programProfit': 'Profitto del Programma',
  'backoffice.profits.lastMonth.title': 'Profitti dei Conti del Mese Scorso',
  'backoffice.profits.lastMonth.totalProfit': 'Profitto Totale del Mese Scorso',
  'backoffice.profits.lastMonth.accountProfit': 'Profitto del Conto',
  'backoffice.profits.lastMonth.programProfit': 'Profitto del Programma',
  'backoffice.profits.overtime.title': 'Profitti dei Conti nel Tempo',
  'backoffice.profits.overtime.chartTitle': 'Cronologia Profitti (Ultimi 12 Mesi)',
  'backoffice.profits.breakdown.title': 'Suddivisione per Conto',
  'backoffice.profits.breakdown.accountNumber': 'Numero Conto',
  'backoffice.profits.breakdown.broker': 'Broker',
  'backoffice.profits.breakdown.balance': 'Saldo',
  'backoffice.profits.breakdown.accountProfit': 'Profitto del Conto',
  'backoffice.profits.breakdown.programProfit': 'Profitto del Programma',
  'backoffice.profits.breakdown.totalProfit': 'Profitto Totale',
  'backoffice.profits.breakdown.noAccounts': 'Nessun conto trovato',
  'backoffice.profits.history.filters.account': 'Conto',
  'backoffice.profits.history.filters.allAccounts': 'Tutti i Conti',
  'backoffice.profits.history.filters.dateFrom': 'Data Inizio',
  'backoffice.profits.history.filters.dateTo': 'Data Fine',
  'backoffice.profits.history.filters.apply': 'Applica Filtri',
  'backoffice.profits.history.filters.reset': 'Reset',
  'backoffice.profits.history.table.title': 'Cronologia Profitti',
  'backoffice.profits.history.table.account': 'Conto',
  'backoffice.profits.history.table.period': 'Periodo',
  'backoffice.profits.history.table.accountProfit': 'Profitto del Conto',
  'backoffice.profits.history.table.exportCSV': 'Esporta CSV',
  'backoffice.profits.history.pagination.showing': 'Mostrando',
  'backoffice.profits.history.pagination.of': 'di',
  'backoffice.profits.history.pagination.results': 'risultati',
  'backoffice.profits.history.pagination.page': 'Pagina',
  'backoffice.profits.history.pagination.previous': 'Precedente',
  'backoffice.profits.history.pagination.next': 'Successiva',
  'backoffice.profits.history.pagination.loadMore': 'Carica Altri',
  'backoffice.profits.commissions.lifetime.title': 'Commissioni a Vita',
  'backoffice.profits.commissions.lastMonth.title': 'Commissioni del Mese Scorso',
  'backoffice.profits.commissions.balance.title': 'Saldo Attuale',
  'backoffice.profits.commissions.balance.lastUpdated': 'Ultimo aggiornamento:',
  'backoffice.profits.commissions.paid.title': 'Totale Pagato',
  'backoffice.profits.commissions.overtime.title': 'Commissioni nel Tempo',
  'backoffice.profits.commissionsHistory.filters.level': 'Livello',
  'backoffice.profits.commissionsHistory.filters.allLevels': 'Tutti i Livelli',
  'backoffice.profits.commissionsHistory.filters.levelNumber': 'Livello {{level}}',
  'backoffice.profits.commissionsHistory.table.title': 'Cronologia Commissioni',
  'backoffice.profits.commissionsHistory.table.date': 'Data',
  'backoffice.profits.commissionsHistory.table.level': 'Livello',
  'backoffice.profits.commissionsHistory.table.levelCompany': 'Azienda',
  'backoffice.profits.commissionsHistory.table.levelLeftover': 'Residuo',
  'backoffice.profits.commissionsHistory.table.commission': 'Commissione',
  'backoffice.profits.commissionsHistory.table.levelNumber': 'Livello {{level}}',
  'backoffice.profits.commissionsPaymentHistory.filters.status': 'Stato',
  'backoffice.profits.commissionsPaymentHistory.filters.allStatuses': 'Tutti gli Stati',
  'backoffice.profits.commissionsPaymentHistory.filters.paymentMethod': 'Metodo di Pagamento',
  'backoffice.profits.commissionsPaymentHistory.filters.allPaymentMethods': 'Tutti i Metodi di Pagamento',
  'backoffice.profits.commissionsPaymentHistory.filters.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.filters.bank': 'Bonifico Bancario',
  'backoffice.profits.commissionsPaymentHistory.table.title': 'Cronologia Pagamenti Commissioni',
  'backoffice.profits.commissionsPaymentHistory.table.date': 'Data',
  'backoffice.profits.commissionsPaymentHistory.table.paymentMethod': 'Metodo di Pagamento',
  'backoffice.profits.commissionsPaymentHistory.table.status': 'Stato',
  'backoffice.profits.commissionsPaymentHistory.table.amount': 'Importo',
  'backoffice.profits.commissionsPaymentHistory.table.exportCSV': 'Esporta CSV',
  'backoffice.profits.commissionsPaymentHistory.status.paid': 'Pagato',
  'backoffice.profits.commissionsPaymentHistory.status.completed': 'Completato',
  'backoffice.profits.commissionsPaymentHistory.status.pending': 'In Attesa',
  'backoffice.profits.commissionsPaymentHistory.status.cancelled': 'Annullato',
  'backoffice.profits.commissionsPaymentHistory.status.failed': 'Fallito',
  'backoffice.profits.commissionsPaymentHistory.status.rejected': 'Rifiutato',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.bank': 'Bonifico Bancario',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.unknown': 'Sconosciuto'
};
